import EzloActions from '../EzloActions';
import { hubScenesCreate } from 'api/localMeshBot';
import { sequence } from '../common';

/**
 * Converts a system MeshBot to a custom MeshBot by creating a new rule, disabling the original, and refreshing the list.
 *
 * This function handles the workflow when a user edits a system MeshBot:
 * 1. Creates a new custom rule based on the edited system MeshBot
 * 2. Disables the original system MeshBot
 * 3. Refreshes the scenes list to reflect changes
 *
 * @param {string} serial - Hub serial number
 * @param {Object} rule - The edited rule configuration (see hubScenesCreate for structure)
 * @param {string} meshBotId - ID of the original system MeshBot to disable
 * @returns {Function} Redux thunk function
 *
 * @example
 * const editedRule = {
 *   enabled: true,
 *   name: "Custom Motion Alert", // edited name
 *   when: [{ blockType: "when", ... }],
 *   then: [{ blockType: "then", ... }], // modified actions
 *   house_modes: ["1", "2"] // changed house modes
 * };
 *
 * dispatch(saveEditedSystemMeshBot("90004631", editedRule, "system-meshbot-uuid-123"));
 */
export const saveEditedSystemMeshBot = (serial, rule, meshBotId) => async (dispatch) =>
    await dispatch(
        sequence([
            [hubScenesCreate, [serial, rule]],
            [EzloActions.offRule, [serial, meshBotId]],
            [EzloActions.refreshSceneList, [serial]],
        ]),
    );
